(function () {
    angular.module('tradersyard').component('tyGroupInvitationModal', {
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<',
            modalInstance: '<',
        },
        controller: GroupInvitationModalCtrl,
        // language=HTML
        template: `
            <div class="modal-header">
                <h4 class="modal-title"><i class="fa fa-user-plus"></i> Invite People</h4>
            </div>
            <uib-tabset justified="true" is-uib>
                <uib-tab ng-repeat="tab in $ctrl.tabs" heading="{{tab.heading}}">
                    <div class="modal-body" ng-switch="tab.type">
                        <ty-invitations-screen-invite-participants
                                ng-switch-when="parent-group"
                                entry-type="{{$ctrl.resolve.entryType}}"
                                entry-id="{{$ctrl.resolve.entryId}}"
                                parent-entries="$ctrl.parentEntryFilter">
                        </ty-invitations-screen-invite-participants>

                        <ty-invitations-screen-invite-friends
                                ng-switch-when="my-friends"
                                entry-type="{{$ctrl.resolve.entryType}}"
                                entry-id="{{$ctrl.resolve.entryId}}">
                        </ty-invitations-screen-invite-friends>

                        <ty-invitations-screen-invite-participants
                                ng-switch-when="my-groups"
                                entry-type="{{$ctrl.resolve.entryType}}"
                                entry-id="{{$ctrl.resolve.entryId}}"
                                parent-entries="$ctrl.groups">
                        </ty-invitations-screen-invite-participants>

                        <ty-invitations-screen-invite-via-email
                                ng-switch-when="email"
                                entry-type="{{$ctrl.resolve.entryType}}"
                                entry-id="{{$ctrl.resolve.entryId}}">
                        </ty-invitations-screen-invite-via-email>
                    </div>
                </uib-tab>
            </uib-tabset>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" ng-click="$ctrl.close()">
                    Close
                </button>
            </div>
        `,
    });

    GroupInvitationModalCtrl.$inject = ['graph-participant-factory'];

    /**
     * @property {{[entryType]: string, [entryId]: string|number, [parentEntry]: string}} resolve
     * @param participantApiFactory
     * @constructor
     */
    function GroupInvitationModalCtrl(participantApiFactory) {
        const ctrl = this;

        ctrl.tabs = [];

        ctrl.groups = [];

        ctrl.parentEntryFilter = [];

        ctrl.$onInit = $onInit;

        let participantApi;

        function $onInit() {
            // create API services
            const { entryType, entryId, parentEntry } = ctrl.resolve;

            if (!entryType || !entryId) {
                console.warn('You need to pass entryType and entryId to the invitation modal');
                return;
            }

            // we pass a string, but we need an array for the child component
            ctrl.parentEntryFilter = parentEntry ? [parentEntry] : [];

            participantApi = participantApiFactory.entry(entryType, entryId);

            _getOwnedGroups()
                .then((data) => data.map(_makeGroupToken))
                .then((groups) => (ctrl.groups = groups));

            this.tabs = _getTabs(parentEntry);
        }

        function _getOwnedGroups() {
            const params = { page: 1, limit: 100 };

            return participantApi.ownership({ params }).then(function (response) {
                return response.data.state === 0 ? response.data.data ?? [] : Promise.reject([]);
            });
        }

        function _makeGroupToken(group) {
            return [group.place.name, group.place.id].join('.');
        }

        function _getTabs(parentEntry) {
            const tabs = [
                {
                    heading: 'from Friend List',
                    type: 'my-friends',
                },
                {
                    heading: 'from my Trading Groups',
                    type: 'my-groups',
                },
                {
                    heading: 'via e-mail',
                    type: 'email',
                },
            ];

            if (parentEntry) {
                tabs.unshift({
                    heading: 'from parent Trading Group',
                    type: 'parent-group',
                });
            }

            return tabs;
        }
    }
})();
